"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _TemperatureStatusModule = _interopRequireDefault(require("../../styles/components/Circles/TemperatureStatus.module.css"));
var _hooks = require("../../hooks");
var _useGetValue = require("../../hooks/useGetValue");
var _function = require("../../utils/function");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TemperatureStatus = _ref => {
  var _useSelector;
  let {
    thingPDIDDevice,
    displayNameIds
  } = _ref;
  const temperaturesData = (0, _useGetValue.useGetValuesByDisplayNameIds)({
    thingPDIDDevice,
    displayNameIds
  });
  const singleTemperature = displayNameIds.length <= 1;
  /** @todo change translation number to key */
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const tVDefault = (_useSelector = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues)) === null || _useSelector === void 0 ? void 0 : _useSelector.Default;
  const showDelta = (0, _react.useRef)(true);
  const errorText = (0, _react.useMemo)(() => {
    let tempShowDelta = true;
    const result = temperaturesData.reduce((acc, _ref2) => {
      let {
        temperatureStatus = {},
        displayNameId
      } = _ref2;
      if (temperatureStatus.key === _paulCorePackage.constants.tempStatusKey.wrongData || temperatureStatus.key === _paulCorePackage.constants.tempStatusKey.noData) tempShowDelta = false;
      if (temperatureStatus.key !== _paulCorePackage.constants.tempStatusKey.optimal) {
        const positionValue = (0, _function.getPositionText)({
          displayNameId,
          tVDefault
        });
        return tI[temperatureStatus.statusTextKey] ? "".concat(acc).concat(positionValue ? "".concat(positionValue, ": ") : '').concat(tI[temperatureStatus.statusTextKey], " \n") : acc;
      }
      return acc;
    }, '');
    showDelta.current = tempShowDelta;
    return result;
  }, [temperaturesData, tI, tVDefault]);
  const generalInformation = (0, _react.useMemo)(() => {
    var _temperaturesData$;
    if (singleTemperature) {
      var _tI$temperatureStatus;
      const {
        temperatureStatus = {}
      } = temperaturesData[0] || {};
      const temperatureStatusTranslationKey = 31;
      return (_tI$temperatureStatus = tI[temperatureStatus === null || temperatureStatus === void 0 ? void 0 : temperatureStatus.statusTextKey]) !== null && _tI$temperatureStatus !== void 0 ? _tI$temperatureStatus : tI[temperatureStatusTranslationKey]; // No data available
    }

    if (!showDelta.current) {
      return null;
    }
    const delta = temperaturesData.reduce((accumulator, item) => {
      const temperature = item.valueType === _paulCorePackage.constants.valueType.float ? Number(item.value) : 0;
      return Math.abs((accumulator === null || accumulator === void 0 ? void 0 : accumulator.toFixed(1)) - (temperature === null || temperature === void 0 ? void 0 : temperature.toFixed(1)));
    }, 0);
    const defaultTemperatureUnitValue = 130;
    const unit = ((_temperaturesData$ = temperaturesData[0]) === null || _temperaturesData$ === void 0 ? void 0 : _temperaturesData$.unit) || defaultTemperatureUnitValue;
    const temperatureInformationTranslationKey = 67;
    return "".concat(tI[temperatureInformationTranslationKey] || '', " ").concat(delta === null || delta === void 0 ? void 0 : delta.toFixed(1)).concat((tVDefault === null || tVDefault === void 0 ? void 0 : tVDefault.unit[unit]) || '--'); // The temperature difference is
  }, [temperaturesData, tI, tVDefault, singleTemperature]);
  const {
    temperatureStatus = {}
  } = (0, _hooks.useGetValueByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex
  });
  /** @todo change translation number to key */
  const {
    [temperatureStatus === null || temperatureStatus === void 0 ? void 0 : temperatureStatus.statusTextKey]: textStatus,
    31: noData
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: _TemperatureStatusModule.default.sub_box
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TemperatureStatusModule.default.subtitle
  }, errorText && !singleTemperature && /*#__PURE__*/_react.default.createElement("span", null, errorText !== null && errorText !== void 0 ? errorText : noData), generalInformation && /*#__PURE__*/_react.default.createElement("span", null, generalInformation))), [temperatureStatus, thingPDIDDevice, textStatus, noData, errorText, generalInformation, singleTemperature]);
};
var _default = exports.default = TemperatureStatus;